import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';

import { Typography } from "antd";

import { reportIssue } from "store/app/actions";

import ReportIssueForm from "components/Contact/ReportIssueForm";

import './index.scss';

const { Title } = Typography;

export interface ReportIssuesPageProps {
  reportIssue(form: Object): any,
  isReporting: boolean,
}

const ReportIssuesPage = (props: ReportIssuesPageProps) => {

  return (
    <div className="report-issue-page">
      <div className="header-title">
        <Title level={4} className="ml-3">Report an Issue</Title>
      </div>
      <div className="search-section justify-content-center row">
        <ReportIssueForm
          reportIssue={props.reportIssue}
          isReporting={props.isReporting}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (store: RootStateOrAny) => ({
  isReporting: store.rootReducer.app.isReporting,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    reportIssue,
  },
  dispatch,
);
export default connect(mapStateToProps, mapDispatchToProps)(ReportIssuesPage);